import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { UtilsService } from './utils.service';

@Injectable()
export class TransfersService {
  constructor(
    private http: HttpService,
    private utils: UtilsService,
  ) {}

  getTransfers(page: number = 1, page_size: number = 10) {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', page_size.toString());

    return new Promise((resolve, reject) => {
      this.http.get(`transfers`, params).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  addTransfer(body: any) {
    return this.http.post(`transfer/create`, body);
  }
}
